module.exports = __webpack_public_path__ + "static/media/left-arrow.2e1be646.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/left-arrow.svg
// module id = 1740
// module chunks = 0